export interface MobileAuthParams {
  email: string;
  source: string;
  redirect_uri: string;
  state: string;
}

export const getMobileAuthParams = (): MobileAuthParams | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email');
  const source = urlParams.get('source');
  const redirect_uri = urlParams.get('redirect_uri');
  const state = urlParams.get('state');
  
  if (source === 'mobile' && email && redirect_uri && state) {
    return { email, source, redirect_uri, state };
  }
  return null;
};

export const storeMobileParams = (params: MobileAuthParams) => {
  sessionStorage.setItem('mobile_auth_params', JSON.stringify(params));
};

export const getMobileParams = (): MobileAuthParams | null => {
  const stored = sessionStorage.getItem('mobile_auth_params');
  return stored ? JSON.parse(stored) : null;
};

// ************************ SSO Provider Storage ************************
export interface SSOProvider {
  name: string;
  state: string;
  email?: string;
}

export const storeSSOProvider = (provider: SSOProvider) => {
  sessionStorage.setItem('sso_provider', JSON.stringify(provider));
};

export const getSSOProvider = (): SSOProvider | null => {
  const stored = sessionStorage.getItem('sso_provider');
  return stored ? JSON.parse(stored) : null;
};

export const clearSSOProvider = () => {
  sessionStorage.removeItem('sso_provider');
};